import { ComponentRef, Injectable, inject } from '@angular/core';
import { OpenWindowParams, WindowService, WindowTemplateComponent } from '@tpt/common/dialogs/window';
import { DialogsStoreService } from '@app/services/dialogs/dialogs-store.service';

// registers @tpt windows in the dialogs store so they close on navigation and Esc like legacy dialogs
@Injectable()
export class TiWindowService extends WindowService {
  private readonly dialogsStoreService = inject(DialogsStoreService);

  override open<TComponent extends WindowTemplateComponent>(
    opt: OpenWindowParams<TComponent>,
  ): { close: () => void; cmpRef?: ComponentRef<TComponent> } {
    const handle = super.open<TComponent>({
      ...opt,
      onClose: (res) => {
        this.dialogsStoreService.remove(handle);
        opt.onClose?.(res);
      },
    });

    this.dialogsStoreService.add({ dialog: handle, destroy: () => handle.close() });

    return handle;
  }
}
